/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FC, memo } from 'react';
import CallRestrictionNotification from './notification';
import { Variant } from '../../../typings/meta-call-restrictions';
import useGetMetaCallRestrictions from '../../../hooks/use-get-meta-call-restrictions';

const CallRestrictionNotificationsOverlay: FC = memo(function CallRestrictionNotificationsOverlay() {
  const { getRestrictedWabaDetails, getViolatedWabaDetails } = useGetMetaCallRestrictions();

  const violated = getViolatedWabaDetails();
  const restricted = getRestrictedWabaDetails();

  const violatedWabaNames = violated.map((violation) => violation?.displayName);
  const restrictedWabaNames = restricted.map((restriction) => restriction?.displayName);

  return (
    <div
      css={css`
        position: fixed;
        bottom: 24px;
        right: 24px;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <CallRestrictionNotification
        variant={Variant.Warning}
        channelName={violatedWabaNames ?? []}
        show={violatedWabaNames?.length > 0}
      />
      <CallRestrictionNotification
        variant={Variant.Restricted}
        channelName={restrictedWabaNames ?? []}
        show={restrictedWabaNames?.length > 0}
      />
    </div>
  );
});

export default CallRestrictionNotificationsOverlay;
